/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CampaignStepListEntry } from './CampaignStepListEntry';
import {
    CampaignStepListEntryFromJSON,
    CampaignStepListEntryFromJSONTyped,
    CampaignStepListEntryToJSON,
} from './CampaignStepListEntry';

/**
 * 
 * @export
 * @interface FindAllCampaignSteps200Response
 */
export interface FindAllCampaignSteps200Response {
    /**
     * 
     * @type {Array<CampaignStepListEntry>}
     * @memberof FindAllCampaignSteps200Response
     */
    data?: Array<CampaignStepListEntry>;
}

/**
 * Check if a given object implements the FindAllCampaignSteps200Response interface.
 */
export function instanceOfFindAllCampaignSteps200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCampaignSteps200ResponseFromJSON(json: any): FindAllCampaignSteps200Response {
    return FindAllCampaignSteps200ResponseFromJSONTyped(json, false);
}

export function FindAllCampaignSteps200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCampaignSteps200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CampaignStepListEntryFromJSON)),
    };
}

export function FindAllCampaignSteps200ResponseToJSON(value?: FindAllCampaignSteps200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CampaignStepListEntryToJSON)),
    };
}

